import { TableauToken } from '../components/dashboard/dashboard-view';
import useRestService from '../shared/rest-service';

const useTableau = (clientId: number) => {
  const { fetchWrapper } = useRestService();

  const fetchTableauToken = (): Promise<TableauToken> => {
    return fetchWrapper(`api/token/${clientId}/tableau`).catch((error) => error);
  };

  return {
    fetchTableauToken
  };
};

export default useTableau;
